import ClientStats from "shared/util/ClientStats";
import Sookie from "shared/util/Sookie";

const SOOKIE_NAME = "timezone_info";
const SOOKIE_HASH = "c012ce7bb343ebee389e48f513824fa79d66c436";

export default {
	offset: 0,

	initialize(_sookie) {
		let sookie;

		if (_sookie) {
			sookie = { ..._sookie };
		}

		// factor in DST if it's set (i.e., work with old sookies)
		if (sookie && sookie.is_dst && sookie.dst_offset) {
			sookie.offset += sookie.dst_offset;
		}

		const offset = 0 - (new Date().getTimezoneOffset());

		if (!sookie || offset !== sookie.offset) {
			this.update(offset);
		}
	},

	update(offset) {
		ClientStats.update("timezone updated");

		if (!offset) {
			return;
		}

		const now = new Date().getTime();
		const t = Math.floor(now / 1000) + 86400 * 365 * 5;
		const newsookie = { offset };

		Sookie.set(SOOKIE_NAME, newsookie, t, SOOKIE_HASH);
	},
};



// WEBPACK FOOTER //
// ./src/shared/util/Timezone.js